import { Button, Text, Image } from "components/commons";
import styles from "./expense-list.module.scss";
import { dateTimeFormat, formatAmount } from "utils";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import TooltipBubble from "components/commons/tooltip/tooltip-bubble.module";
import { ViewAttachment } from "images";

export const mapDataToList = ({
  expenses,
  imageUrl: selectedImageUrl,
  onClickViewSlip,
  onClickView,
}) => {
  const { expenseId, shift, createdAt, amount, remarks, imageUrl, type } = expenses;
  const willTruncate = remarks?.length > 20;
  const displayed = willTruncate ? `${remarks.slice(0, 20)}...` : remarks ? remarks : "--";

  return {
    expenseId: (
      <>
        <Text className={styles}>{expenseId ?? ""}</Text>
      </>
    ),
    shiftDate: (
      <>
        <Text className={styles.td}>{`${dateTimeFormat(shift?.startShift) ?? ""} -`}</Text>
        <Text className={styles.td}>{`${dateTimeFormat(shift?.endShift) ?? ""}`}</Text>
      </>
    ),
    expenseDateAndTime: (
      <>
        <Text className={styles.td}>{dateTimeFormat(createdAt) ?? ""}</Text>
      </>
    ),
    type: (
      <>
        <Text className={styles.td}>{type ?? ""}</Text>
      </>
    ),
    amount: (
      <>
        <Text className={styles.td}>{formatAmount(amount) ?? ""}</Text>
      </>
    ),
    remarks: (
      <>
        <TooltipBubble content={remarks}>
          <span>{displayed}</span>
        </TooltipBubble>
      </>
    ),
    viewAttachment: (
      <Button
        style={{ textDecoration: "none", background: !imageUrl ? "none" : undefined }}
        link
        onClick={() => onClickViewSlip(imageUrl)}
        disabled={!imageUrl}
      >
        <Image src={ViewAttachment} className={imageUrl ? styles.iconCustom : ""} />
      </Button>
    ),
    action: (
      <Button style={{ textDecoration: "none" }} link onClick={() => onClickView?.(expenseId)}>
        <div
          style={{
            color: "#5349b7",
            fontWeight: "500",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <span>View</span>
          <NavigateNextIcon fontSize="small" />
        </div>
      </Button>
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { type, ...fs } = filterState;

  return {
    ...fs,
    type: !type.isSelectedAll ? type.value.join(",") : undefined,
  };
};
